export default __webpack_public_path__ + "static/media/359.59bb9c47.png";